import ApiClientInterface from "@lib/ApiClient/ApiClientInterface";
import { InjectionToken } from "tsyringe";

import { TrackingApiService } from "./services/TrackingApiService";

export const trackingApiServiceToken = Symbol(
    "trackingApiServiceToken"
) as InjectionToken<TrackingApiService>;

export const legacyTrackingApiClient = Symbol(
    "legacyTrackingApiClient"
) as InjectionToken<ApiClientInterface>;
